<template>
	<v-card flat outlined>
		<v-container fluid class="pb-0">
			<v-row>
				<v-col cols="12" lg="12" class="pb-0 pt-0">
					<v-card flat class="pb-0 pt-0">
						<v-card-text class="pb-0 pt-2">
							<v-row>
								<v-col class="pb-0 pt-0">
									<v-card-title class="justify-center align-center pa-2 pb-0 pt-0">
										{{ $t('titles.teacherContracts') }}</v-card-title
									>
								</v-col>
							</v-row>
							<v-row>
								<v-col class="pt-0">
									<TheTable
										:additional-filters="teacherContractsTable.additionalFilters"
										:default-sort="teacherContractsTable.defaultSort"
										:excel="false"
										:fields="teacherContractsTable.headers"
										:header-selection-key="'teacher-contracts-headers'"
										:height="teacherContractsTable.height"
										:total-records="teacherContractsTable.total"
										@headers="selectHeaders"
										@reload="reloadData"
									>
										<tr
											v-for="(item, key) in teacherContractsTable.items"
											:key="key"
											:class="{ 'cursor-pointer': true }"
										>
											<td
												v-if="teacherContractsTable.selectedHeaders.includes('contract_number')"
											>
												{{ item.contract_number }}
											</td>
											<td v-if="teacherContractsTable.selectedHeaders.includes('start_date')">
												{{
													item.start_date != null
														? item.start_date.split('-').reverse().join('.')
														: ''
												}}
											</td>
											<td v-if="teacherContractsTable.selectedHeaders.includes('end_date')">
												{{
													item.end_date != null
														? item.end_date.split('-').reverse().join('.')
														: ''
												}}
											</td>
											<td
												v-if="
													teacherContractsTable.selectedHeaders.includes('contract_type_id')
												"
											>
												{{ item.contract_type.name }}
											</td>
											<td v-if="teacherContractsTable.selectedHeaders.includes('author_id')">
												{{ item.author.full_name }}
											</td>
										</tr>
									</TheTable>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'TeacherContracts',
	components: { TheTable },
	props: {
		teacherId: [String, Number],
	},
	data: function () {
		return {
			teacherContractsTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.contractNumber'),
						value: 'contract_number',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{ text: this.$t('fields.startDate'), value: 'start_date', type: '', allowFilter: true },
					{
						text: this.$t('fields.endDate'),
						value: 'end_date',
						type: '',
						allowFilter: true,
					},
					{
						text: this.$t('fields.contractType'),
						value: 'contract_type_id',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.author'),
						value: 'author_id',
						type: '',
						sortable: false,
						allowFilter: true,
					},
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'start_date',
					descending: true,
				},
			},
		};
	},
	methods: {
		selectHeaders(headers) {
			this.teacherContractsTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.teacherContractsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'teachers-contracts/' + this.teacherId,
				request,
				(data, success) => {
					if (success) {
						vm.teacherContractsTable.items = data.items;
						vm.teacherContractsTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.teacherContractsTable.height = window.innerHeight - 310 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
